// extracted by mini-css-extract-plugin
export var layoutContainer = "_at-0";
export var layoutContainerNoRounding = "_at-6";
export var layoutContainerOpen = "_at-5";
export var layoutContainerResizing = "_at-1";
export var mainContent = "_at-2";
export var resizeDivider = "_at-3";
export var slidePanel = "_at-4";